<template>
  <div id="run-midpoint-study-modal" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <div class="d-flex align-items-center p-3">
            <div class="centered-circle flex-shrink-0 bg-secondary text-primary h-10 w-10">
              <font-awesome-icon :icon="['fas', 'arrows-spin']" />
            </div>
            <div class="ms-3">
              <h3 class="fs-5 spacing-close">Run Midpoint Study</h3>
            </div>
          </div>

          <!-- Content Here -->
          <form>
            <div class="mb-3">
              <label for="startDate" class="form-label">Start Date (Optional)</label>
              <input
                v-model="startDate"
                type="date"
                class="form-control"
                id="startDate"
              />
              <small class="form-text text-muted">
                If not entered, will use the study's startDate
              </small>
            </div>

            <div class="mb-3">
              <label for="endDate" class="form-label">End Date (Optional)</label>
              <input
                v-model="endDate"
                type="date"
                class="form-control"
                id="endDate"
              />
              <small class="form-text text-muted">
                If not entered, will use the study's endDate and postStudyEndDate. If entered, this will override both endDate and postStudyEndDate.
              </small>
            </div>

            <div class="alert alert-info">
              <small>
                <strong>Note:</strong> If no dates are entered, the study's original startDate, endDate, and postStudyEndDate will be used. 
                If dates are provided, startDate will override the study's startDate, and endDate will override both endDate and postStudyEndDate.
              </small>
            </div>
          </form>
          <!-- end content -->
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary font-sm"
            style="min-width: 150px"
            @click="onOkClick"
          >
            Run Study
          </button>
          <button
            type="button"
            class="btn btn-outline-primary font-sm"
            data-bs-dismiss="modal"
            style="min-width: 150px"
            @click="noHandler"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as dayjs from "dayjs";

export default {
  name: "RunMidpointStudyModal",
  props: {
    yesEvent: Function,
    study: Object,
  },
  data() {
    return {
      model: streetmetrics.model,
      currentModal: null,
      modalElement: null,
      errorMessage: null,
      startDate: "",
      endDate: "",
    };
  },
  computed: {},
  mounted() {
    this.modalElement = document.getElementById("run-midpoint-study-modal");
    this.currentModal = new bootstrap.Modal(this.modalElement);

    this.modalElement.addEventListener("hidden.bs.modal", () => {
      this.$emit("noEvent");
    });

    this.currentModal.show();
  },
  beforeDestroy() {
    this.modalElement.removeEventListener("hidden.bs.modal");
  },
  watch: {
    study: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          // Pre-populate with study dates as placeholders (but they're optional)
          if (newValue.startDate) {
            this.startDate = dayjs(newValue.startDate * 1000).format("YYYY-MM-DD");
          }
          if (newValue.endDate) {
            this.endDate = dayjs(newValue.endDate * 1000).format("YYYY-MM-DD");
          }
        } else {
          // Reset dates when study is cleared
          this.startDate = "";
          this.endDate = "";
        }
      },
    },
  },
  methods: {
    onSaveClick() {
      this.errorMessage = null;
    },

    noHandler(e) {
      // Reset dates when closing
      this.startDate = "";
      this.endDate = "";
      // hide the modal
      this.currentModal.hide();
    },
    onOkClick() {
      // Convert dates to Unix timestamps if provided, otherwise pass undefined
      let startDateUnix = undefined;
      let endDateUnix = undefined;

      if (this.startDate) {
        startDateUnix = dayjs(this.startDate).unix();
      }

      if (this.endDate) {
        endDateUnix = dayjs(this.endDate).unix();
      }

      // call the parent's "yesEvent" with the dates
      if (this.yesEvent) {
        this.yesEvent(this.study, startDateUnix, endDateUnix);
      }
      // Reset dates after submission
      this.startDate = "";
      this.endDate = "";
      // hide the modal
      this.noHandler();
    },
  },
};
</script>

<style></style>

